/* ==========================================================================
   Mundo Dos Filtros — product-form.js
   Seleção de variantes (via Section Rendering API) e adicionar ao carrinho.
   ========================================================================== */

(function () {
  'use strict';

  var rotas = (window.tema && window.tema.rotas) || {};
  var textos = (window.tema && window.tema.textos) || {};

  function $(seletor, escopo) {
    return (escopo || document).querySelector(seletor);
  }

  function $$(seletor, escopo) {
    return Array.prototype.slice.call((escopo || document).querySelectorAll(seletor));
  }

  /* --------------------------------------------------- Adicionar item -- */

  function adicionar(form, botao) {
    atualizarTotalMetros(form.closest('[data-produto]'));
    var dados = new FormData(form);
    dados.append('sections', 'cart-drawer');

    var textoOriginal = botao ? botao.innerHTML : '';
    if (botao) {
      botao.disabled = true;
      botao.innerHTML = '<span class="spinner" aria-hidden="true"></span>';
    }

    return fetch(rotas.adicionar + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: dados
    })
      .then(function (resposta) {
        return resposta.json().then(function (corpo) {
          if (!resposta.ok) throw corpo;
          return corpo;
        });
      })
      .then(function () {
        if (window.temaCarrinho) return window.temaCarrinho.atualizar(true);
      })
      .catch(function (erro) {
        mostrarErro(form, (erro && erro.description) || textos.erroCarrinho);
      })
      .finally(function () {
        if (botao) {
          botao.disabled = false;
          botao.innerHTML = textoOriginal;
        }
      });
  }

  /* ------------------------------------------- Teto pelo que já foi ao -- */
  /*                                                            carrinho   */

  /* O seletor já nasce limitado ao estoque da variante, mas isso ignora o que
     a pessoa colocou no carrinho antes: com 2 em estoque e 2 no carrinho, o
     limite real é zero. Sem descontar, o pedido só era recusado lá no fim. */
  function aplicarTeto(container, carrinho) {
    var input = $('[data-estoque-total], [data-teto]', container);
    if (!input) return;

    /* Dois tetos possíveis: o estoque da variante e o limite por pedido
       (mangueira vendida por metro). Vale o menor; qualquer um pode faltar. */
    var estoque = parseInt(input.getAttribute('data-estoque-total'), 10);
    var limite = parseInt(input.getAttribute('data-teto'), 10);
    if (isNaN(estoque) && isNaN(limite)) return;
    var total = Math.min(isNaN(estoque) ? Infinity : estoque, isNaN(limite) ? Infinity : limite);

    var campo = $('[data-variante-id]', container);
    var varianteId = campo ? parseInt(campo.value, 10) : 0;
    if (!varianteId) return;

    var usado = 0;
    (carrinho.items || []).forEach(function (item) {
      if (item.id === varianteId) usado += item.quantity;
    });

    var restante = Math.max(0, total - usado);
    input.setAttribute('max', restante);

    var valor = parseInt(input.value, 10) || 1;
    if (valor > restante) input.value = Math.max(1, restante);

    /* Sem saldo sobrando o botão sai de cena: deixar clicável só levaria a um
       erro do servidor depois do clique. Variante esgotada não chega aqui —
       nesse caso o Liquid nem emite o data-estoque-total. */
    var botao = $('[data-adicionar]', container);
    if (botao) botao.disabled = restante <= 0;

    var aviso = $('[data-produto-limite]', container);
    if (aviso) aviso.hidden = restante > 0;

    atualizarTotalMetros(container);
  }

  /* ------------------------------------------------ Venda por metro --- */

  /* Mangueira: a quantidade é a metragem e o preço é o de 1 metro. O total
     aparece na hora, antes de ir para o carrinho — a conta final continua
     sendo da Shopify (quantidade × preço), aqui é só o espelho dela. */
  function atualizarTotalMetros(container) {
    var input = $('[data-metros]', container || document);
    if (!input) return;

    var escopo = input.closest('[data-produto]') || document;
    var alvo = $('[data-metros-total]', escopo);
    var preco = parseInt(input.getAttribute('data-preco-metro'), 10);
    if (!alvo || isNaN(preco)) return;

    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var max = parseInt(input.getAttribute('max'), 10);
    var metros = parseInt(input.value, 10);
    if (isNaN(metros) || metros < min) metros = min;
    if (!isNaN(max) && max >= min && metros > max) metros = max;

    /* O campo visível fica fora do formulário; o que vai para o carrinho (e
       para o "Comprar agora") é a quantidade escondida dentro dele. */
    var oculto = $('[data-metros-quantidade]', escopo);
    if (oculto) oculto.value = metros;

    var total = preco * metros;
    var dinheiro = window.temaUtils.formatarDinheiro;
    alvo.textContent = metros + ' m × ' + dinheiro(preco) + ' = ';
    var forte = document.createElement('strong');
    forte.textContent = dinheiro(total);
    alvo.appendChild(forte);

    atualizarParcelasMetros(escopo, total);
  }

  /* Parcelamento e Pix do total da metragem. Mesma regra do snippet
     payment-terms.liquid, refeita aqui porque o total muda a cada metro: com
     poucos metros o valor não alcança a parcela mínima e não há parcelamento;
     conforme a metragem sobe, as parcelas aparecem e aumentam. As divisões são
     inteiras, em centavos, como as do Liquid. */
  function atualizarParcelasMetros(escopo, total) {
    var bloco = $('[data-produto-metros]', escopo);
    if (!bloco) return;

    function numero(nome) {
      var valor = parseInt(bloco.getAttribute(nome), 10);
      return isNaN(valor) ? 0 : valor;
    }

    /* As linhas ficam no bloco de preço, fora do bloco de metros; os números
       da regra continuam vindo do bloco de metros. */
    var linhaParcelas = $('[data-metros-parcelas]', escopo);
    if (linhaParcelas) {
      var maximo = numero('data-max-parcelas');
      var limite = numero('data-parcelas-limite');
      if (limite > 0 && total < limite) maximo = numero('data-max-parcelas-reduzido');
      /* A tag "parcelas-N" do produto é a exceção manual e ganha da faixa. */
      if (numero('data-parcelas-tag') > 0) maximo = numero('data-parcelas-tag');

      var minimo = numero('data-parcela-minima');
      var parcelas = 1;
      for (var n = 1; n <= maximo; n++) {
        if (Math.floor(total / n) >= minimo) parcelas = n;
      }

      var mostrar = bloco.getAttribute('data-mostrar-parcelas') === 'true' && parcelas > 1;
      linhaParcelas.hidden = !mostrar;
      if (mostrar) {
        $('[data-metros-parcelas-texto]', linhaParcelas).textContent =
          parcelas + 'x de ' + window.temaUtils.formatarDinheiro(Math.floor(total / parcelas));
      }
    }

    var linhaPix = $('[data-metros-pix]', escopo);
    if (linhaPix) {
      var desconto = numero('data-desconto-pix');
      linhaPix.hidden = !(desconto > 0);
      if (desconto > 0) {
        $('[data-metros-pix-valor]', linhaPix).textContent =
          window.temaUtils.formatarDinheiro(Math.floor((total * (100 - desconto)) / 100));
      }
    }
  }

  function conferirTeto(container) {
    var alvo = container || $('[data-produto]');
    if (!alvo || !$('[data-estoque-total], [data-teto]', alvo)) return;

    fetch(rotas.carrinho + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) { aplicarTeto(alvo, carrinho); })
      .catch(function () {
        /* Carrinho fora do ar: fica o teto do estoque puro, que é o que já
           havia antes. Melhor do que travar a compra. */
      });
  }

  function mostrarErro(form, mensagem) {
    var caixa = $('[data-produto-erro]', form);
    if (!caixa) return;
    caixa.textContent = mensagem;
    caixa.hidden = false;
    window.setTimeout(function () { caixa.hidden = true; }, 6000);
  }

  /* ------------------------------------------------ Trocar de variante -- */

  /* Deixa "esgotado" cada valor de opção que, junto com o que já está
     escolhido nas outras opções, não leva a nenhuma variante disponível.
     O input fica disabled — o CSS (`:has(input:disabled)`) escurece e risca,
     e o radio desabilitado não responde ao clique no label. O valor que já
     está marcado nunca é travado: se ele esgotou, quem avisa é o botão. */
  function sincronizarDisponibilidadeOpcoes(container, variantes) {
    var grupos = $$('[data-opcoes] .produto__opcao', container);
    /* Uma opção só: cada valor já é uma variante inteira e o botão de compra
       cobre o caso de esgotado. Travar aqui só tiraria a chance de ver o preço. */
    if (grupos.length < 2) return;

    if (!variantes) {
      var dados = $('[data-variantes]', container);
      if (!dados) return;
      try {
        variantes = JSON.parse(dados.textContent || '[]');
      } catch (e) {
        return;
      }
    }

    var atual = grupos.map(function (grupo) {
      var marcado = $('input[data-opcao]:checked', grupo);
      return marcado ? marcado.value : null;
    });

    grupos.forEach(function (grupo, gi) {
      $$('input[data-opcao]', grupo).forEach(function (input) {
        if (input.checked) {
          input.disabled = false;
          return;
        }
        var possivel = variantes.some(function (v) {
          if (!v.available) return false;
          return v.options.every(function (opcao, i) {
            if (i === gi) return opcao === input.value;
            return atual[i] == null || opcao === atual[i];
          });
        });
        input.disabled = !possivel;
      });
    });
  }

  /* Número do pedido mais recente de troca de variante. Trocar de cor rápido
     dispara vários fetch da seção, e eles não voltam na ordem em que saíram:
     sem este controle, uma resposta antiga chegava depois e reescrevia o bloco
     de compra com preço/estoque da cor anterior — daí o botão "piscando" e o
     conteúdo que "bugava e voltava". Cada resposta fora de ordem é descartada. */
  var pedidoVariante = 0;

  function atualizarVariante(container) {
    var form = $('[data-produto-form]', container);
    var url = container.getAttribute('data-produto-url');
    var secao = container.getAttribute('data-secao-id');
    if (!form || !url || !secao) return;

    var selecionados = $$('[data-opcoes] input[type="radio"]:checked, [data-opcoes] select', container).map(
      function (campo) {
        return campo.value;
      }
    );

    /* Sem a lista de variantes não há o que trocar. Ler o textContent de um
       nó ausente estouraria aqui e derrubaria o listener de change junto —
       o clique na opção passaria a não fazer absolutamente nada. */
    var dados = $('[data-variantes]', container);
    if (!dados) return;

    var variantes = JSON.parse(dados.textContent || '[]');

    /* Antes de resolver a variante escolhida: reavalia o que ainda dá para
       escolher nas outras opções e trava os valores esgotados. */
    sincronizarDisponibilidadeOpcoes(container, variantes);

    var variante = variantes.find(function (item) {
      return item.options.every(function (opcao, i) {
        return opcao === selecionados[i];
      });
    });

    var inputId = $('[data-variante-id]', form);

    if (!variante) {
      if (inputId) inputId.value = '';
      marcarIndisponivel(container);
      return;
    }

    if (inputId) inputId.value = variante.id;

    /* A mídia e o SKU já estão disponíveis no JSON da página. Atualizá-los
       imediatamente evita deixar a opção antiga visível enquanto a Shopify
       renderiza preço, estoque e botões em uma segunda requisição. */
    var sku = $('[data-produto-sku]', container);
    if (sku) {
      sku.textContent = variante.sku
        ? (variante.sku_label || 'SKU') + ': ' + variante.sku
        : '';
    }

    if (variante.media_id) {
      trocarImagem(container, String(variante.media_id));
    }

    var novaUrl = new URL(url, window.location.origin);
    novaUrl.searchParams.set('variant', variante.id);
    window.history.replaceState({}, '', novaUrl.toString());

    container.classList.add('carregando');
    var pedido = ++pedidoVariante;

    fetch(novaUrl.pathname + novaUrl.search + '&section_id=' + secao)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        /* Já saiu um pedido mais novo: esta resposta é de uma cor que o
           usuário nem está mais vendo. Aplicá-la deixaria o bloco de compra
           fora de sincronia com a opção marcada. */
        if (pedido !== pedidoVariante) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');

        ['[data-produto-preco]', '[data-produto-estoque]', '[data-produto-compra]', '[data-produto-sku]'].forEach(
          function (seletor) {
            var novo = doc.querySelector(seletor);
            var atual = $(seletor, container);
            if (novo && atual) atual.innerHTML = novo.innerHTML;
          }
        );
      })
      .finally(function () {
        /* Só o último pedido limpa o estado de carregamento e reacomoda a
           página; os anteriores saem de cena sem tocar em nada. */
        if (pedido !== pedidoVariante) return;

        container.classList.remove('carregando');
        /* A troca de preço e estoque pode mudar a altura da coluna ao lado e
           reacomodar a galeria, então reposicionamos depois que tudo assentou.
           Aqui sem animação: a faixa já deslizou quando a foto trocou, e repetir
           o movimento agora daria um segundo solavanco fora de hora. */
        centralizarMiniAtiva(false);
        /* O bloco de compra foi reescrito: o seletor voltou ao teto bruto da
           nova variante e precisa descontar o carrinho de novo. */
        conferirTeto(container);
      });
  }

  function marcarIndisponivel(container) {
    var botao = $('[data-adicionar]', container);
    if (!botao) return;
    botao.disabled = true;
    botao.textContent = textos.esgotado || 'Indisponível';
  }

  /* -------------------------------------------------------- Galeria --- */

  /* Número do pedido mais recente de troca de imagem. Clicar rápido em várias
     miniaturas dispara vários downloads, e eles não voltam na ordem em que
     foram pedidos: sem este controle, uma resposta lenta chegava depois de uma
     mais nova e a sobrescrevia, fazendo a galeria "voltar" sozinha. */
  var pedidoGaleria = 0;

  /* Atribuir o src direto deixa a foto antiga na tela até a nova terminar de
     baixar e decodificar — é daí que vem o atraso em que uma parece passar por
     cima da outra. Carregamos fora da tela e só trocamos quando a imagem já
     está pronta para pintar, então a troca acontece de uma vez só. */
  function aplicarImagem(principal, url, alt) {
    var pedido = ++pedidoGaleria;

    var mostrar = function () {
      /* Chegou atrasada e já existe pedido mais novo: descarta. */
      if (pedido !== pedidoGaleria) return;
      principal.src = url;
      principal.srcset = '';
      principal.alt = alt;
    };

    var pre = new Image();
    pre.src = url;

    if (pre.decode) {
      /* decode() falha em alguns navegadores para imagem vinda do cache; nesse
         caso trocamos mesmo assim, que é o comportamento antigo. */
      pre.decode().then(mostrar).catch(mostrar);
    } else if (pre.complete) {
      mostrar();
    } else {
      pre.onload = mostrar;
      pre.onerror = mostrar;
    }
  }

  /* A foto seguinte e a anterior entram no cache assim que a atual aparece.
     Quem navega com as setas quase nunca espera download, que é o caso em que
     o atraso incomodava mais. */
  function preCarregarVizinhas(minis, indice) {
    if (minis.length < 2) return;

    [indice - 1, indice + 1].forEach(function (i) {
      var alvo = minis[(i + minis.length) % minis.length];
      var imagem = alvo && $('img', alvo);
      var url = imagem && imagem.getAttribute('data-grande');
      if (url) new Image().src = url;
    });
  }

  function trocarImagem(container, midiaId) {
    var principal = $('[data-galeria-principal] img', container);
    var mini = $('[data-galeria-mini="' + midiaId + '"]', container);
    if (!principal || !mini) return;

    var imagem = $('img', mini);
    if (!imagem) return;

    aplicarImagem(principal, imagem.getAttribute('data-grande') || imagem.src, imagem.alt);

    var minis = $$('[data-galeria-mini]', container);
    minis.forEach(function (item) {
      item.setAttribute('aria-current', item === mini ? 'true' : 'false');
    });

    preCarregarVizinhas(minis, minis.indexOf(mini));

    /* Um quadro de espera antes de rolar: a troca de foto principal pode mudar
       a altura da coluna e reacomodar a faixa, e medir antes disso dava um alvo
       que já não valia quando a rolagem começava. */
    window.requestAnimationFrame(function () {
      trazerMiniParaVista(mini, true);
    });
  }

  /* A faixa de miniaturas rola na horizontal, então a miniatura da variante
     escolhida costuma estar fora de vista. Ela desliza até o centro da faixa —
     rolando só a faixa, nunca a página. */
  function menosMovimento() {
    return !!(
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /* Quem rola de verdade nem sempre é o pai direto da miniatura: basta alguém
     envolver os botões num wrapper para o scrollLeft ser aplicado no elemento
     errado, e aí nada se move. Subimos até achar quem tem conteúdo além da
     largura visível. */
  function faixaDe(mini) {
    var no = mini.parentElement;
    while (no && no !== document.body) {
      if (no.scrollWidth - no.clientWidth > 1) return no;
      no = no.parentElement;
    }
    return null;
  }

  function trazerMiniParaVista(mini, suave) {
    if (!mini) return;

    var faixa = faixaDe(mini);
    if (!faixa) return;

    var maximo = faixa.scrollWidth - faixa.clientWidth;
    if (maximo <= 0) return;

    /* A conta sai das posições reais na tela, não do offsetLeft. O offsetLeft é
       medido a partir do primeiro ancestral posicionado, então qualquer mudança
       de position no CSS da faixa mandava a rolagem para o lugar errado — ou
       para lugar nenhum. Com getBoundingClientRect a distância é sempre entre o
       centro da miniatura e o centro da faixa, seja qual for a estrutura.

       Atribuir scrollLeft, em vez de scrollIntoView, continua sendo o caminho:
       é a única forma que não mexe em nenhum outro elemento da página. */
    var caixaFaixa = faixa.getBoundingClientRect();
    var caixaMini = mini.getBoundingClientRect();
    var desvio =
      caixaMini.left + caixaMini.width / 2 - (caixaFaixa.left + caixaFaixa.width / 2);

    var alvo = faixa.scrollLeft + desvio;
    alvo = Math.max(0, Math.min(alvo, maximo));

    /* Já está no lugar: sair aqui evita uma animação de zero pixel, que em
       alguns navegadores cancela a rolagem suave que viria logo depois. */
    if (Math.abs(faixa.scrollLeft - alvo) < 1) return;

    /* A faixa desliza até a miniatura em vez de saltar. O salto acontecia rápido
       demais para se perceber que a foto escolhida mudou de posição; deslizando,
       o olho acompanha o movimento e entende que aquela é a cor selecionada.
       No primeiro carregamento e para quem pede menos movimento, vai direto. */
    if (suave && !menosMovimento() && faixa.scrollTo) {
      faixa.scrollTo({ left: alvo, behavior: 'smooth' });
    } else {
      faixa.scrollLeft = alvo;
    }
  }

  /* Ao abrir a página já com uma variante escolhida, a miniatura ativa vem
     marcada pelo servidor e nenhuma troca acontece — sem isso a faixa ficaria
     parada no começo, escondendo a foto que está em exibição. */
  function centralizarMiniAtiva(suave) {
    $$('[data-galeria-mini][aria-current="true"]').forEach(function (mini) {
      trazerMiniParaVista(mini, suave);
    });
  }

  /* As setas andam pela mesma lista das miniaturas e dão a volta nas pontas,
     então a imagem ativa continua sendo a fonte da verdade. */
  function navegarGaleria(container, passo) {
    var minis = $$('[data-galeria-mini]', container);
    if (minis.length < 2) return;

    var atual = 0;
    minis.forEach(function (item, indice) {
      if (item.getAttribute('aria-current') === 'true') atual = indice;
    });

    var destino = (atual + passo + minis.length) % minis.length;
    trocarImagem(container, minis[destino].getAttribute('data-galeria-mini'));
  }

  /* --------------------------------------------------------- Eventos -- */

  function iniciar() {
    document.addEventListener('submit', function (evento) {
      var form = evento.target.closest('[data-produto-form]');
      if (!form) return;
      if (form.getAttribute('data-ajax') === 'false') return;

      atualizarTotalMetros(form.closest('[data-produto]'));

      /* O botão "Comprar agora" da Shopify envia o mesmo formulário, mas com
         destino ao checkout. Se interceptássemos aqui, ele viraria um
         "adicionar ao carrinho" comum e o cliente nunca sairia da página. */
      var enviador = evento.submitter;
      if (enviador && enviador.name === 'checkout') return;

      evento.preventDefault();
      adicionar(form, $('[data-adicionar]', form));
    });

    document.addEventListener('change', function (evento) {
      var campo = evento.target.closest('[data-opcao]');
      if (!campo) return;

      var container = campo.closest('[data-produto]');
      if (container) atualizarVariante(container);
    }, true);

    document.addEventListener('click', function (evento) {
      var rotuloOpcao = evento.target.closest('[data-opcoes] label');
      if (rotuloOpcao) {
        var campoOpcao = $('[data-opcao]', rotuloOpcao);
        var containerOpcao = campoOpcao && campoOpcao.closest('[data-produto]');

        /* O clique do label acontece antes de o radio ficar marcado. Executar
           no proximo ciclo garante que a combinacao nova ja esteja ativa. */
        if (containerOpcao) {
          window.setTimeout(function () {
            atualizarVariante(containerOpcao);
          }, 0);
        }
        return;
      }

      var seta = evento.target.closest('[data-galeria-anterior], [data-galeria-proximo]');
      if (seta) {
        evento.preventDefault();
        var containerSeta = seta.closest('[data-produto]') || document;
        navegarGaleria(containerSeta, seta.hasAttribute('data-galeria-proximo') ? 1 : -1);
        return;
      }

      var mini = evento.target.closest('[data-galeria-mini]');
      if (!mini) return;

      evento.preventDefault();
      var container = mini.closest('[data-produto]') || document;
      trocarImagem(container, mini.getAttribute('data-galeria-mini'));
    }, true);

    /* 'input' acompanha a digitação; 'change' pega os botões de mais e menos
       e a correção de valor fora do limite, que o theme.js faz no mesmo evento. */
    ['input', 'change'].forEach(function (tipo) {
      document.addEventListener(tipo, function (evento) {
        var campo = evento.target;
        if (!campo.matches || !campo.matches('[data-metros]')) return;

        /* Passou do limite: volta para o máximo na hora, ainda durante a
           digitação. Sem isto o campo mostrava 45 até perder o foco, e só
           então o theme.js corrigia para o teto. */
        var teto = parseInt(campo.getAttribute('max'), 10);
        if (!isNaN(teto) && parseInt(campo.value, 10) > teto) campo.value = Math.max(1, teto);
        var containerMetros = campo.closest('[data-produto]');
        window.setTimeout(function () { atualizarTotalMetros(containerMetros); }, 0);
      });
    });

    /* Link com a metragem já escolhida (o atendimento manda
       ".../products/mangueira-x?metros=12"): o campo abre preenchido, dentro
       do mesmo limite de quem digita. */
    var metrosDoLink = parseInt(new URLSearchParams(window.location.search).get('metros'), 10);
    var campoMetros = $('[data-metros]', document);
    if (campoMetros && metrosDoLink >= 1) {
      var tetoDoLink = parseInt(campoMetros.getAttribute('max'), 10);
      campoMetros.value = !isNaN(tetoDoLink) && tetoDoLink >= 1 && metrosDoLink > tetoDoLink
        ? tetoDoLink
        : metrosDoLink;
    }
    atualizarTotalMetros();

    centralizarMiniAtiva();
    /* No editor de temas a seção é remontada; a faixa volta ao início. O
       listener não passa o evento adiante: ele viraria o argumento "suave" e
       ligaria a animação numa remontagem, onde ela não faz sentido. */
    document.addEventListener('shopify:section:load', function () {
      centralizarMiniAtiva(false);
    });

    /* Vizinhas da foto inicial, para o primeiro clique na seta já ser
       instantâneo em vez de esperar o primeiro download. */
    var galeria = $('[data-produto]');
    if (galeria) {
      var minis = $$('[data-galeria-mini]', galeria);
      var atual = 0;
      minis.forEach(function (item, indice) {
        if (item.getAttribute('aria-current') === 'true') atual = indice;
      });
      preCarregarVizinhas(minis, atual);
    }

    conferirTeto();

    /* Estado inicial: trava os valores de opção esgotados já no carregamento,
       sem esperar o primeiro clique. */
    $$('[data-produto]').forEach(function (c) {
      sincronizarDisponibilidadeOpcoes(c);
    });

    /* Mexer na quantidade dentro do drawer muda o saldo disponível aqui.
       O evento já traz o carrinho, então não repetimos a consulta. */
    document.addEventListener('tema:carrinho', function (evento) {
      var alvo = $('[data-produto]');
      if (alvo && evento.detail) aplicarTeto(alvo, evento.detail);
    });
  }

  /* Todos os listeners são delegados no document, então sobrevivem ao
     recarregamento de seções no editor de temas — não reinicializar aqui. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
